import MenuComponent from '@/components/MenuComponent'
import ActualitesComponent from '@/components/ActualitesComponent'
import MenuConnexion from '@/components/MenuConnexion'
import BlocAuthenticated from '@/components/BlocAuthenticated'
import { PeriodeSearch } from '@/models/periodesearch.model'
import { OperationSearch } from '@/models/operationssearch.model'
import { EntrepriseSearch } from '@/models/entreprisesearch.model'

export default {
  data () {
    return {
      rechercheOperation: new OperationSearch(),
      recherchePeriode: new PeriodeSearch(),
      rechercheEntreprise: new EntrepriseSearch(),
      listPeriodes: [],
      loading: false
    }
  },
  components: {
    MenuComponent,
    MenuConnexion,
    BlocAuthenticated,
    ActualitesComponent
  },
  methods: {
    format_date (value) {
      var moment = require('moment')
      if (value) {
        return moment(value).format('DD/MM/YYYY')
      }
    },
    getPeriodesToDisplay (editedPeriod) {
      this.loading = true
      this.$store.dispatch('porteur/selectEditedPeriod', null)
      this.$store.dispatch('entreprise/selectListOperations', null)

      this.rechercheOperation.login = this.$store.state.user.user.login
      this.rechercheOperation.entrepriseId = this.$store.state.user.user.selectedEntreprise ? this.$store.state.user.user.selectedEntreprise.entrepriseId : null
      this.rechercheOperation.groupName = this.$store.state.user.user.groupe.name
      this.rechercheOperation.periodId = editedPeriod.periodeId
      this.rechercheOperation.entityId = this.$store.state.user.user.selectedEntreprise.entityId
      this.rechercheOperation.selectedPeriod = editedPeriod

      this.$store.dispatch('entreprise/searchOperations', this.rechercheOperation).then(
        response => {
          this.$store.dispatch('porteur/selectEditedPeriod', editedPeriod)
          this.$store.dispatch('entreprise/selectListOperations', response)
          this.$router.push({ name: 'entreprise/gestionnaireoperations' })
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    searchEntreprise () {
      this.$store.dispatch('entreprise/searchEntrepriseGestDepenses', this.rechercheEntreprise).then(
        reponseEnt => {
          this.$store.dispatch('user/selectEntreprise', reponseEnt[0])
          this.recherchePeriode.entrepriseId = this.$store.state.entreprise.restrictedEntrepriseIdList[0].entrepriseId
          this.recherchePeriode.entityId = this.$store.state.entreprise.restrictedEntrepriseIdList[0].entityId
          this.getPeriodesForEntreprise()
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    },
    getPeriodesForEntreprise () {
      this.recherchePeriode.groupName = this.$store.state.user.user.groupe.name
      this.$store.dispatch('periode/getPeriodesForEntreprise', this.recherchePeriode).then(
        response => {
          this.loading = false
          this.listPeriodes = response
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    }
  },
  mounted () {
    this.loading = true
    this.recherchePeriode.login = this.$store.state.user.user.login
    this.$store.dispatch('user/selectPeriode', this.editedPeriod)

    if (this.$store.state.user.user.selectedEntreprise) {
      this.recherchePeriode.entrepriseId = this.$store.state.user.user.selectedEntreprise.entrepriseId
    } else if (this.$store.state.user.user.entrepriseId) {
      this.recherchePeriode.entrepriseId = this.$store.state.user.user.entrepriseId

      this.$store.dispatch('user/getEntrepriseById', this.recherchePeriode).then(
        () => {
          this.loading = false
        },
        error => {
          this.loading = false
          this.errorMessage = error.response
        }
      )
    }

    if (this.$store.state.user.user.groupe.name === 'Gestionnaire') {
      this.rechercheEntreprise.userRestricted = true
      this.rechercheEntreprise.restrictedEntrepriseIdList = [this.$store.state.user.user.entrepriseId]
      this.searchEntreprise()
    } else {
      this.getPeriodesForEntreprise()
    }
  },
  beforeCreate () {
    this.$store.state.filArianePage = 'Dépenses Entreprise'
    this.$store.state.filArianeMiddlePage = null
    this.$store.state.filArianeMiddleRouterLink = null

    this.$store.dispatch('porteur/selectEditedPeriod', null)
    this.$store.dispatch('porteur/selectListOperationsCarte', null)
  }
}
